import loading from './loading';
import menu from './menu';
import scroll from './scroll';
import navigation from './navigation';

export default () => {
	loading();
	menu();
	scroll();
	navigation();
};
